type TypographyProps = {
  variant?:
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6'
    | 'subtitle1'
    | 'subtitle2'
    | 'body1'
    | 'body2'
    | 'body3'
    | 'caption'
    | 'button'
    | 'overline'
  color?: string
  align?: 'left' | 'center' | 'right' | 'justify'
  gutterBottom?: boolean
  className?: string
  children: React.ReactNode
}

const variantMapping = {
  h1: 'text-6xl',
  h2: 'text-5xl',
  h3: 'text-4xl',
  h4: 'text-3xl',
  h5: 'text-2xl',
  h6: 'text-xl',
  subtitle1: 'text-lg',
  subtitle2: 'text-md',
  body1: 'text-base',
  body2: 'text-sm',
  body3: 'text-xs',
  caption: 'text-xs text-doss-border',
  button: 'text-sm',
  overline: 'text-xs uppercase',
}

export const Typography: React.FC<TypographyProps> = ({
  variant = 'body1',
  color = 'text-gray-10',
  align = 'left',
  gutterBottom = false,
  className = '',
  children,
}) => {
  const style = `${variantMapping[variant]} ${color} text-${align} ${
    gutterBottom ? 'mb-4' : ''
  } ${className}`

  return <div className={style}>{children}</div>
}

export default Typography
